import { Spinner } from "react-bootstrap";

export const Loader = () => (
  <div
    className="d-flex justify-content-center align-items-center"
    style={{ minHeight: "40vh" }}
  >
    <Spinner
      animation="border"
      role="status"
      style={{ color: "#556b2f", width: "2rem", height: "2rem" }}
    >
      <span className="visually-hidden">Loading...</span>
    </Spinner>
  </div>
);
